import React, { useEffect } from 'react';
import Footer from "../../../components/Footer/Footer";
import { useNavigate } from "react-router-dom";
import { useScrollHeader } from '../../../hooks';
import NewsSidebar from "../../../components/NewsSidebar/NewsSidebar";

export default function Invest({ setHeaderDark }) {
  useScrollHeader(setHeaderDark, 50); // 50px 触发
  const navigate = useNavigate();

  const newsData = [
    {
      title: 'ARVO 2017新兴趋势和热点话题丨双眼增强现实范式用于成人弱视治疗',
      date: '2024-08',
      desc: '复旦大学附属眼耳鼻喉科医院眼科孙兴怀教授、刘红主任、文雯博士与美国加州大学的李响博士合作，将增强现实和双眼训练相结合，研发了一种双眼分视的训练新模式并用于成年弱视…',
      img: '/images/news/arvo1.png',
      route: '/newsInfo/arvo'
    },
    {
      title: '深耕临床前沿，聚力视康革新｜集视双城眼科学术盛会完美落幕',
      date: '2026-06-07',
      desc: '6月4日-7日，集视医疗双线奔赴宁波VDT学术交流会、沈阳非公医疗眼科年会双城行业盛会。以学术交流为核心，以技术展示为载体，与全国眼科同仁共探全龄弱视诊疗新方向，共启视光康复行业新机遇。至此，集视双城学术之旅圆满收官！',
      img: '/images/news/twoCitiesAcademic2.jpg',
      route: '/newsInfo/twoCitiesAcademic'
    },
    {
      title: 'Cell Reports重磅：首次揭示成人弱视神经学病理机制，首创全龄优效弱视诊疗方案',
      date: '2026-06',
      desc: '北京时间 2021 年 12 月 14 日，国际顶级学术期刊《Cell Reports》在线发表了由复旦大学附属眼耳鼻喉科医院文雯团队和中科院生物物理所张朋团队领衔的研究成果《成人人类弱视中膝状 - 纹状与皮质 - 顶盖通路的层选择性信号缺失与增强》。该研究联合 3T 和 7T 超高分辨率 BOLD fMRI 技术，结合精心设计的大细胞（M）/ 小细胞（P）通路特异性视觉刺激，对 17 名单侧弱视成人患者和 17 名正常对照者进行了对照研究，取得了里程碑式的发现',
      img: '/images/news/cellReportsAmblyopia5.jpg',
      route: '/newsInfo/cellReportsAmblyopia'
    },
  ]

  useEffect(() => {
    window.scrollTo(0, 0); // 进入页面时滚动到顶部
  }, []);

  return <div>
    <div className="nav">
      <div className="AcademicMargin flex_row flex_jc-sb flex_ai-c gap_10" style={{ height: '100%' }}>
        <div className='nav_title c_ff'>公司动态 / 最新资讯 / 集视科技获远毅资本天使轮投资，为2700万全年龄段弱视患者提供基于XR技术的视觉训练方法</div>
        <div
          className='fz_20 fw_500 lh_24 c_ff cur_p flex_row flex_ai-c'
          onClick={(() => navigate('/companyNews', { replace: true }))}
        >
          <img
            className='nav_arrow'
            src='/images/news/left.png'
            alt=''
          />
          <div className='nav_back'>返回页面</div>
        </div>
      </div>
    </div>
    <div className="AcademicBlock">
      <div className='PreA_left'>
        <div className='PreA_marginMobile flex_col flex_jc-sb'>
          <div>
            <div className="article_title">
              <div className='article_titleTop c_85899E'>
                公司动态 / 公司资讯
                <span className='ml_54'>2024.08</span>
              </div>
              <div className="article_titleBottom">集视科技获远毅资本天使轮投资，为2700万全年龄段弱视患者提供基于XR技术的视觉训练方法</div>
            </div>
            <div className="article_content">
              <div className="article_content-text">
                苏州集视医疗科技有限公司（简称“集视医疗”）宣布完成由远毅资本独家投资的天使轮融资。资金将用于其自研的基于混合现实XR技术的视觉训练方法的研发与落地。<br />
                集视医疗成立于2020年，是一家以产学研联动为抓手，致力于常见眼病治疗与防控的整体解决方案的高新技术企业。当前公司产品已覆盖了弱视、干眼和眼末端患者的需求，并在弱视治疗领域的数字疗法形成了自主知识产权。
              </div>
              <div className="PreA_img2">
                <img
                  style={{ width: '100%' }}
                  src='/images/news/invest1.png'
                  alt=''
                />
              </div>
              <div className="article_content-text">
                我国弱视患者比例超5%，传统遮盖疗法疗效有限，对于大龄患者接近无效。<br />
                弱视是发生在儿童时期的常见眼病，也是影响儿童视觉发育的主要眼病之一。通常是在视觉发育早期竞争发育的双眼刺激输入失去平衡引发的结果。 弱视不仅会导致最佳矫正视力下降，还会导致注视异常、色觉及暗适应异常，甚至在儿童视觉发育的敏感期和关键期引起立体视发育异常，严重影响儿童身心健康。
                <br />
                <br />
                传统遮盖治疗虽简便易行，但存在疗效有限（部分患者在长时间遮盖后仍无法达到正常视力或在遮盖治疗停止后发生一定程度的回退）、双眼功能缺陷、立体视功能受损等问题， 并且遮盖会对患儿外观及生活产生影响，可能导致自卑、不合群等群里问题，实际依从性较差，治疗效果往往难尽人意，且易复发。
                <br />
                <br />
                一般来讲，弱视治疗在12岁是一个临界点，12岁以后再治疗效果微乎其微。长久以来，在弱视临床研究领域，人们对12岁以后的弱视（在12岁前治疗失败或未得到有效治疗者）几乎不采取任何治疗措施。 弱视如得不到有效治疗，则可引起永久性视觉损失。
              </div>
              <div className="article_content-text1">牵手中科院研发基于混合现实XR技术的视觉训练方法</div>
              <div className="article_content-text">
                弱视的发病机制较为复杂，通常不仅是眼睛问题，还与视觉信息的传导与脑中枢的视觉感知有关。
                <br />
                集视医疗和中科院合作引入磁共振技术发现，弱视患者有小细胞层损伤，这类细胞主要介导精细觉、颜色，所以弱视患者的精细分辨率或视力更差。
                集视医疗首次活体完整揭示弱视患者的神经环路损害，并首次提出“双机制假说”，即在单眼状态下，有一个上行的小细胞通路的损伤，在患者双眼一起工作时，
                好的眼睛会对坏的眼睛有一个强的抑制作用，从而加重损伤。
                <br />
                <br />
                基于以上理论，集视医疗联合国内知名眼科临床专家联合研发了基于混合现实XR技术的视觉训练方法，通过特定的图像刺激算法重新激活弱视患者的细胞层修复，
                从而实现弱视的视力恢复，且效果面向全年龄段有效，是弱视领域的重大突破。
                <br />
                该视觉训练方案主要包含两方面，一方面是硬件的革新，利用一些日常情景，比如佩戴混合现实XR眼镜进行自由学习、工作、吃饭等，不影响正常生活，大大提高患者的依从性；
                另一方面是训练机制的革新，联合双眼推拉训练，针对双机制损伤训练，可替代传统遮盖疗法治疗大龄儿童和成人弱视甚或达到治愈的目的。
              </div>
              <div className="PreA_img2">
                <img
                  style={{ width: '100%' }}
                  src='/images/news/invest2.png'
                  alt=''
                />
              </div>
              <div className="article_content-text">
                对于本次融资，集视医疗创始人童晓煜表示：“集视医疗将高分辨率功能磁共振引入青光眼、弱视等神经性眼病机制研究解决临床问题，未来我们也将研发多项应用于眼病诊疗的新范式。
                我们希望可以利用科研手段更真实客观的揭示疾病机制，破解临床诊疗难题，同时将研究成果转化为创新性技术，依据市场落地产品，依据患者使用和恢复情况不断调整技术形态，
                形成完整闭环。集视医疗未来还会瞄准和布局更多的眼科赛道，结合脑认知和临床研究解决更多复杂问题。”
                <br />
                远毅资本投资副总裁李阳先生表示：“集视医疗由全球领先的脑科学、眼科临床、可穿戴技术深度融合的产学研团队组成，结合脑科学深入研究眼科相关疾病的发病机制并设计针对性诊疗范式，
                开发基于可穿戴设备、符合临床路径、个性化、高依从性的诊疗产品。从成人弱视切入，未来拓展到低视力、青光眼、干眼等全方位眼健康数字化管理，全面提升眼科治疗的整体水平，
                改善患者的生活质量，弥补当前眼科治疗的短板。”
              </div>
              <div className="article_content-text1">关于远毅资本</div>
              <div className="article_content-text">
                远毅资本成立于2016年，是一家专注于数字医疗技术领域的早期风险投资基金。目前，管理的多支人民币和美元基金累计投资管理规模超过30亿人民币。
                <br />
                远毅深耕数字医疗早期和增长期的投资机会，在数字医疗的高效触达、创新支付以及效率提升这三大基础设施方面实现前瞻性布局。
                远毅资本已在拥有核心技术和创新商业模式的医疗器械和设备、精准诊断、移动医疗和服务以及医疗保险科技公司。
                近几年投资的项目主要包括AI医学影像龙头数坤科技，医疗创新支付领导者镁信健康，齿科3D打印设备公司迅实科技，医疗器械B2B流通平台贝登医疗，五官科介入器械企业莱诺医疗等。
              </div>
            </div>
          </div>
          <div className='article_content'>
            <div className='article_content-iconBlock'>
              <div className='PreA_left-icon flex_center'>
                <img
                  src='/images/news/Share_icon.png'
                  alt=''
                />
              </div>
              <div className='PreA_left-icon flex_center'>
                <img
                  src='/images/news/Collection_icon.png'
                  alt=''
                />
              </div>
              <div className='PreA_left-icon flex_center'>
                <img
                  src='/images/news/link_icon.png'
                  alt=''
                />
              </div>
            </div>
            <div className='article_content-btnBlock'>
              {/* Pc端 */}
              <div
                className='article_content-btnPc fz_20 fw_500 lh_24 cur_p flex_row flex_ai-c'
                onClick={(() => navigate('/newsInfo/bestEnterprise'))}
              >
                <img
                  className='nav_arrow mr_10'
                  src='/images/news/blackLeft.png'
                  alt=''
                />
                阅读上一篇资讯
              </div>
              <div
                className='article_content-btnPc fz_20 fw_500 lh_24 cur_p flex_row flex_ai-c'
                onClick={(() => navigate('/newsInfo/arvo'))}
              >
                阅读下一篇资讯
                <img
                  className='nav_arrow ml_10'
                  src='/images/news/blackRight.png'
                  alt=''
                />
              </div>
              {/* 移动端 */}
              <div
                className='article_content-btnMobile fz_16 fw_400 lh_18 cur_p flex_row flex_ai-c'
                onClick={(() => navigate('/newsInfo/bestEnterprise'))}
              >
                <img
                  className='nav_arrow mr_6'
                  src='/images/news/blackLeft.png'
                  alt=''
                />
                上一篇
              </div>
              <div
                className='article_content-btnMobile fz_16 fw_400 lh_18 cur_p flex_row flex_ai-c'
                onClick={(() => navigate('/newsInfo/arvo'))}
              >
                下一篇
                <img
                  className='nav_arrow ml_6'
                  src='/images/news/blackRight.png'
                  alt=''
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <NewsSidebar newsData={newsData} />
    </div>
    <Footer />
  </div>
}
